import { useQuery, UseQueryResult } from "@tanstack/react-query"
import { trpcRetry } from "#/lib/trpc/retryPolicy"
import { LocationDetails } from "../types/Location"
import { trpc } from "#/lib/trpc/client"

const LOCATION_DETAILS_QUERY_KEY = "GetLocationDetails"

export function useGetLocationDetails(locationString: string): UseQueryResult<LocationDetails, Error> {
  return useQuery<LocationDetails, Error>(
    [LOCATION_DETAILS_QUERY_KEY, locationString],
    async () => {
      const response = await trpc.location.geocode.query({ address: locationString })
      // Google ZERO_RESULTS resolves to null upstream — surface as an error
      // so callers that gate on !isError don't fall through with no coords.
      if (!response) {
        throw new Error("Location not found")
      }
      return response
    },
    {
      refetchOnWindowFocus: false,
      retry: trpcRetry(1),
      enabled: !!locationString
    }
  )
}
